import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { DeadlineChip, deadlineFlag, internalFlag, fmtDay } from "@/components/BidOpsChips";

const FIELDS = [
  { key: "due_date", label: "Client due" },
  { key: "internal_due_date", label: "Internal due" },
  { key: "mobilization_date", label: "Mobilization" },
];
const toDateInput = (v) => (v ? String(v).slice(0, 10) : "");
// Internal due is a plain date; the others are stored as ISO timestamps.
const toPayload = (key, val) => (!val ? null : key === "internal_due_date" ? val : new Date(val).toISOString());

// Compact editable strip of the dates an estimate lives or dies by.
export function KeyDatesStrip({ bid, editable, onSaved }) {
  const [nonce, setNonce] = useState(0);
  const save = async (key, val) => {
    try {
      const r = await api.put(`/bids/${bid.bid_id}`, { [key]: toPayload(key, val) });
      onSaved?.(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save date");
      setNonce((n) => n + 1);
    }
  };
  // J: late is judged against the CLIENT due date only; the internal date is a soft reminder; a sent round reads On time / Late
  const open = !["sent", "won", "lost", "cancelled", "declined", "no_bid"].includes(bid.status);
  const flag = open ? deadlineFlag(bid.due_date) : null;
  const iflag = open ? internalFlag(bid.internal_due_date) : null;
  const sentOnTime = bid.sent_at && bid.due_date && !open ? String(bid.sent_at).slice(0, 10) <= String(bid.due_date).slice(0, 10) : null;
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1" data-testid="bid-key-dates">
      {FIELDS.map((f) => (
        <div key={f.key} className="flex items-center gap-1.5">
          <span className="text-[10px] uppercase tracking-wider text-slate-400">{f.label}</span>
          {editable ? (
            <input type="date" data-testid={`keydate-${f.key}`} key={`${f.key}-${bid[f.key] || ""}-${nonce}`}
              defaultValue={toDateInput(bid[f.key])} onChange={(e) => e.target.value !== toDateInput(bid[f.key]) && save(f.key, e.target.value)}
              className="text-[11px] border border-slate-200 rounded px-1.5 py-0.5 text-slate-700 focus:border-[#003E87] outline-none" />
          ) : (
            <span className="text-[11px] text-slate-600">{fmtDay(bid[f.key], true)}</span>
          )}
          {f.key === "internal_due_date" && bid.internal_due_date && bid.internal_due_auto !== false && (
            <span className="text-[9px] uppercase tracking-wide text-slate-400" data-testid="keydate-internal-auto">auto</span>
          )}
        </div>
      ))}
      <DeadlineChip flag={flag} internalFlag={iflag} sentOnTime={sentOnTime} testid="bid-deadline-flag" />
    </div>
  );
}
